import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { axiosInstance } from "../../utils/helper";
import { apiUrlB2B } from "../../utils/constants";

const initialState = {
  latitude: null,
  longitude: null,
  city: null,
  village: null,
  state: null,
  country: null,
  address: null,
  primary_phone: null,
  firstName: null,
  lastName: null,
  email: null,
  postalCode: null,
  district: null,
  customerID: null,
  customerUVID: null,
  token: null,
  refresh_token: null,
  detail: null,
  is_b2b: false,
  location_permission: "idle", // idle | allowed | denied
  companyID: null,

	age_verified: null, // AGE_VERIFICATION_STATUS
};

export const autoRegister = createAsyncThunk(
  "user/autoRegister",
  async (params, { rejectWithValue }) => {
    try {
      const res = await axiosInstance.post(
        `${apiUrlB2B}auth-ufoodx/register`,
        params
      );

      if (res?.data?.statusCode === 200) {
        return res?.data?.data;
      }

      return rejectWithValue("Register failed");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const user = createSlice({
  name: "user",
  initialState,
  reducers: {
    setUser: (state, action) => {
      return { ...state, ...action.payload };
    },
    clearUser: () => {
      return initialState;
    }
  },
//   extraReducers: (builder) => {
//     builder
//       .addCase(autoRegister.pending, (state) => {
//         state.loading = true;
//         state.error = null;
//       })
//       .addCase(autoRegister.fulfilled, (state, action) => {
//         state.loading = false;
//         state.customerID = action.payload.customerID;
//         state.companyID = action.payload.companyID;
//       })
//       .addCase(autoRegister.rejected, (state, action) => {
//         state.loading = false;
//         state.error = action.payload;
//       });
//   }
});

export const { setUser, clearUser } = user.actions;
export default user.reducer;
